module.exports = __webpack_public_path__ + "static/media/efiling-logotype-l.cd01abd1.svg";